import {
  CheckCircle2,
  CheckIcon,
  FileUser,
  Handshake,
  Star,
  UsersRound,
} from "lucide-react";
import CurrentStatus from "../JobDetails/components/CurrentStatus";

const events = [
  {
    label: "Application Submitted",
    value: "Your application has been successfully submitted.",
    icon: CheckIcon,
    bgColor: 'bg-green-600',
  },
  {
    label: "Application Viewed",
    value: "The hiring company has viewed your application.",
    icon: CheckIcon,
    bgColor: 'bg-green-600',
  },
  {
    label: "Interview Scheduled",
    value: "An interview has been scheduled with the hiring team.ur",
    icon: UsersRound,
    bgColor: 'bg-blue-600',
  },
  {
    label: "Shortlisted",
    value: "Congratulations! You have been shortlisted for this role.",
    icon: Star,
    bgColor: null,
  },
  {
    label: "Interview",
    value: "Your interview has been completed.",
    icon: UsersRound,
    bgColor: null,
  },
  {
    label: "Offer",
    value: "An offer has been made to you.",
    icon: FileUser,
    bgColor: null,
  },
  {
    label: "Hired",
    value: "Welcome aboard! You've been hired for this role.",
    icon: Handshake,
    bgColor: null,
  },
];

const Tracker = () => {
  return (
    <div className="flex gap-4">
      {/* Column 1 */}
      <div className="flex flex-col flex-1">
        {/* Application Tracker */}
        <div className="flex flex-col flex-1 border rounded-md p-3 gap-5">
          <div className="flex flex-col gap-1">
            <span className="font-bold text-xs">Application Tracker</span>
            <span className="font-semibold text-xss text-light-black">
              Track the progress of your application in real time.
            </span>
          </div>

          <div className="flex flex-col">
            {events?.map((event, eventIndex) => {
              const lastRow = events?.length === eventIndex + 1;
              return (
                <div className="flex gap-3">
                  <div className="flex flex-col items-center">
                    <div
                      className={`flex items-center justify-center h-6 w-6 rounded-full ${
                        event?.bgColor ? event.bgColor : "bg-light-white-200"
                      }`}
                    >
                      <event.icon
                        className={`h-3.5 w-3.5 ${
                          event?.bgColor ? "text-white" : "text-light-black"
                        }`}
                      />
                    </div>
                    {!lastRow ? (
                      <div className="flex-1 w-px bg-gray-200 my-1"></div>
                    ) : null}
                  </div>
                  <div className={`flex pt-0.5 ${!lastRow ? "pb-7" : ""}`}>
                    <div className="flex flex-col gap-1">
                      <span className="font-semibold text-xss">
                        {event?.label}
                      </span>
                      <span className="font-semibold text-xss text-light-black">
                        {event?.value}
                      </span>
                    </div>
                    <div></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* Column 2 */}
      <div className="w-[30%]">
        <CurrentStatus />
      </div>
    </div>
  );
};

export default Tracker;
